(function (angular, app) {
    "use strict";

    angular.module(app.modules.scoring.name)
       .controller(app.modules.scoring.routes.postascore.controller, PostAScoreController)

    PostAScoreController.$inject = ["$scope", "$q", "$routeParams", "ngDialog", "$timeout", "$interval", "$document"
       , app.modules.common.services.functions
       , app.modules.common.services.storage
       , app.modules.scoring.services.score
       , app.modules.course.services.search
       , app.modules.ui.services.alerts
       , app.modules.common.constants.equipmentlist
       , app.modules.common.constants.appsettings
       , app.modules.ui.services.ui
    ];

    function PostAScoreController($scope, $q, $routeParams, ngDialog, $timeout, $interval, $document
       , ggFunctions
       , ggStorage
       , ggScoringSvc
       , ggCourseSvc
       , ggAlertSvc
       , ggEquipmentList
       , ggAppSettings
       , ggUISvc
       ) {

        // Assign this to object so it can be updated from watcher
        var ctrl = this;

        var now = new Date().getTime();

        // Interval every 2 seconds to update score.-- so no clicking needed
        var interval;
        var mouseInterval;
        $scope.$on('$destroy', function () {

            // Wait, before we leave, save it?
            if ($scope.Score.Temp.isChanged) {
                $scope.f.scoring.saveLocal();
            }

            // Kill the interval timer
            if (angular.isDefined(interval)) {
                $interval.cancel(interval);
                interval = undefined;
            }
        });


        interval = $interval(function () {
            var nd = new Date().getTime();
            // at least 2 seconds passed last change
            if ($scope.Temp.saveState.savedOn < $scope.Temp.saveState.changedOn) {
                if (nd - $scope.Temp.saveState.changedOn > 2500) {
                    if ($scope.Score.Temp.isChanged && !$scope.Temp.saveState.saving) {
                        $scope.f.scoring.saveLocal();
                        //$scope.f.scoring.clickSaveScore(true);
                    }
                }
            }

        }, 2000);

        // Scopes
        $scope.PopupAlert = new ggAlertSvc.popup;
        $scope.Score = null;

        $scope.Temp = {
         isLoaded: false
         , window : ggFunctions.fetchWindowSize()
         , isAdvancedSetup: false
         , currentHoleNumber: 1
         , isScoreSet: false
         , holes: {
             par: []
         }
         , isChanged: false
         , saveState: {
             saving: false
            , isSaved: false
            , changedOn: now
            , savedOn: now
         }
         , tabIndexType: 9
         , maxHoleScore: 16
         , minScore: 27
         , maxScore: 155
         , is9Hole : false
         , preferenceSettings: app.Member.Detail.preferenceSettings
         , equipmentList: ggEquipmentList
        }

        var now = new Date().getTime();

        $scope.View = {
            tabs: {
                current: 1
               , types: {
                   home: 1
                  , setup: 2
                  , stats: 3
               }
               , isActive: function (tab) {
                   return tab == $scope.View.tabs.current;
               }
               , select: function (tab) {


                   if (tab == $scope.View.tabs.types.home) {

                       

                       // make sure we aren't trying to bypass setup
                       if ($scope.Score.id == 0 && (!$scope.Score.localScoreId || $scope.Score.localScoreId == 0)) {
                           $scope.Content.setup.save(true);
                           return;
                       } else {
                           if (ggUISvc.isTouchScreen() && $scope.Score.Temp.preferenceSettings.postHoleByHole) {
                               $scope.f.scoring.openHoleView($scope.Score.Temp.currentHoleNumber);
                           }
                       }
                   }
                   if (tab == $scope.View.tabs.types.setup) {
                       $scope.Content.setup.fill();
                   }
                   $scope.View.tabs.current = tab;
               }
            }
        }

        $scope.Content = {
            init: function () {


                var fetchCourseDetail = function (courseId, teeId) {
                    return ggCourseSvc.search.fetchCourseDetail(courseId, teeId).then(function (data) {
                        if (data && data.status == "200") {
                            $scope.Score.Temp.course = data.data;

                            if ($scope.Score.teeId > 0 && $scope.Score.Temp.course.tees) {
                                for (var t = 0; t < $scope.Score.Temp.course.tees.length; t++) {
                                    if ($scope.Score.teeId == $scope.Score.Temp.course.tees[t].id) {
                                        var tmpTee = $scope.Score.Temp.course.tees[t];
                                        var holes = tmpTee.holes;
                                        holes.sort(function (a, b) { return a.number - b.number });
                                        tmpTee.holes = holes;
                                        $scope.Score.Temp.tee = tmpTee;
                                        break;
                                    }
                                }
                            }
                        }
                        return;
                    }, function () {
                        return $q.resolve();
                    });
                }
                if ($scope.Score.id == 0 && (!$scope.Score.localScoreId || ($scope.Score.localScoreId && $scope.Score.localScoreId == 0))) {
                    $scope.View.tabs.select($scope.View.tabs.types.setup);
                } else {
                    $scope.View.tabs.select($scope.View.tabs.types.home);
                }

                if (app.Member.Handicap && app.Member.Handicap.official) {
                    if (app.Member.Handicap.official.type == "RCGAFactor9Hole" || app.Member.Handicap.official.type == "USGAIndex9Hole") {
                        $scope.Temp.is9Hole = true;
                        $scope.Content.setup.form.holesPlayed = app.modules.scoring.constants.holesPlayed.frontNine;
                    }
                }


                var setupComplete = function () { return $q.resolve() };

                setupComplete().then(function () {
                    if ($scope.Score.id > 0 && (!$scope.Score.localScoreId || ($scope.Score.localScoreId && $scope.Score.localScoreId == 0))) {
                        return fetchCourseDetail($scope.Score.courseId, $scope.Score.teeId);
                    } else {

                        if ($scope.Score.localScoreId == 0 && $scope.Score.gross == 0) {

                            
                            if ($scope.Score.gross == 0) {
                                if ($scope.Score.Temp.course && $scope.Score.Temp.course.tees && $scope.Score.Temp.course.tees.length > 0) {
                                    if ($scope.Score.Temp.course.tees[0].par && $scope.Score.Temp.course.tees[0].par > 0) {
                                        $scope.Score.gross = $scope.Score.Temp.course.tees[0].par;
                                    } else {
                                        $scope.Score.gross = 72;
                                    }
                                }
                            }
                           

                        }

                        $q.resolve();
                    }
                }).finally(function () {
                    ggFunctions.toggleProcessing(false);
                    ggFunctions.scrollToTop(0);
                    $scope.Temp.isLoaded = true;

                });



            }
           , home: {

           }
           , setup: {
               isDirty: false
              , form: {
                  courseId: 0
                 , course: {}
                 , teeId: 0
                 , tee: {}
                 , playDate: null
                 , trackStats: app.Member.Detail.preferenceSettings.trackStats
                 , postHoleByHole: app.Member.Detail.preferenceSettings.postHoleByHole
                 , holesPlayed: app.modules.scoring.constants.holesPlayed.eighteenHoles
                 , isPlayedAlone: false
                 , isPlayedWithClubMember: true
                 , isTournamentScore: false
                 , app: false
                 , scoreType: app.modules.scoring.constants.scoreType.away
                 , attestorName: ""
              }
              , fill: function () {
                  $scope.Content.setup.isDirty = false;
                  $scope.Content.setup.form.playDate = $scope.Score.playDate;
                  $scope.Content.setup.form.holesPlayed = $scope.Score.holesPlayed;
                  $scope.Content.setup.form.isPlayedAlone = $scope.Score.isPlayedAlone;
                  $scope.Content.setup.form.isPlayedWithClubMember = $scope.Score.isPlayedWithClubMember;
                  $scope.Content.setup.form.scoreType = $scope.Score.scoreType;
                  $scope.Content.setup.form.attestorName = $scope.Score.attestorName;

                  if ($scope.Score.scoreType == app.modules.scoring.constants.scoreType.tournament || $scope.Score.scoreType == app.modules.scoring.constants.scoreType.awayTournament) {
                      $scope.Content.setup.form.isTournamentScore = true;
                  } else {
                      $scope.Content.setup.form.isTournamentScore = false;
                  }

                  $scope.Content.setup.form.course = $scope.Score.Temp.course;
                  $scope.Content.setup.form.tee = $scope.Score.Temp.tee;
                  $scope.Content.setup.form.courseId = $scope.Score.courseId;
                  $scope.Content.setup.form.teeId = $scope.Score.teeId;

              }
              , save: function (isValid) {
                  $scope.Content.setup.isDirty = true;


                  //check some vitals..
                  if ($scope.Content.setup.form.courseId == 0 || $scope.Content.setup.form.teeId == 0) {
                      isValid = false;
                      $scope.PopupAlert.warn("Course / Tees", "Please select a golf course and a set of tees.");
                  }
                  if ($scope.Content.setup.form.playDate) {


                      var tomorrow = new Date();
                      tomorrow.setDate(tomorrow.getDate() + 1);  // add 1 day to today
                      var ftomorrow = (tomorrow.getMonth() + 1) + '/' + tomorrow.getDate() + '/' + tomorrow.getFullYear();

                      var today = new Date($scope.Content.setup.form.playDate + "T00:00:00");
                      tomorrow = new Date(ftomorrow);

                      if (tomorrow > today) {
                          // Good Date
                      } else {
                          isValid = false;
                          $scope.PopupAlert.warn("Invalid Date", "Please select a date that is not in the future.");
                      }
                  }

                  if (isValid && $scope.Score) {

                      // Saving from the setup page.  Update scope.  Save to local storage.

                      $scope.Score.courseId = $scope.Content.setup.form.courseId;
                      $scope.Score.courseName = $scope.Content.setup.form.course.name;
                      $scope.Score.teeId = $scope.Content.setup.form.teeId;
                      $scope.Score.teeName = $scope.Content.setup.form.tee.name || "None";

                      $scope.Score.playDate = $scope.Content.setup.form.playDate;

                      $scope.Score.holesPlayed = $scope.Content.setup.form.holesPlayed;
                      $scope.Score.slope = $scope.Content.setup.form.tee.slope;
                      $scope.Score.rating = $scope.Content.setup.form.tee.rating;

                      // Rating
                      if ($scope.Score.holesPlayed ==  app.modules.scoring.constants.holesPlayed.frontNine){
                          $scope.Score.rating = $scope.Content.setup.form.tee.frontRating || ($scope.Content.setup.form.tee.rating / 2);
                      }
                      if ($scope.Score.holesPlayed ==  app.modules.scoring.constants.holesPlayed.backNine){
                          $scope.Score.rating = $scope.Content.setup.form.tee.backRating || ($scope.Content.setup.form.tee.rating / 2);
                      }

                      $scope.Score.isHandicapScore = true;
                      $scope.Score.isPlayedAlone = $scope.Content.setup.form.isPlayedAlone;
                      $scope.Score.isPlayedWithClubMember = $scope.Content.setup.form.isPlayedWithClubMember;

                      if ($scope.Score.isPlayedAlone) {
                          $scope.Score.isHandicapScore = false;
                      }

                      // Score Type
                      if ($scope.Content.setup.form.isTournamentScore) {
                          $scope.Score.scoreType = app.modules.scoring.constants.scoreType.tournament;
                          $scope.Content.setup.form.scoreType = $scope.Score.scoreType;
                      } else {
                          $scope.Score.scoreType = app.modules.scoring.constants.scoreType.away;
                          $scope.Content.setup.form.scoreType = $scope.Score.scoreType;
                      }

                      //$scope.Score.attestorId = $scope.Content.setup.form.attestorId;
                      $scope.Score.attestorName = $scope.Content.setup.form.attestorName;

                      // Hole Scores
                      if ($scope.Content.setup.form.tee && $scope.Content.setup.form.tee.holes && $scope.Score.holeScores.length > 0) {
                          for (var t = 0; t < $scope.Content.setup.form.tee.holes.length; t++) {
                              var hole = $scope.Content.setup.form.tee.holes[t];
                              if (hole && hole.par) {
                                  $scope.Score.holeScores[t].par = hole.par;
                              }
                          }
                      }


                      // Statistics
                      $scope.Score.memberId = app.Member.Detail.id
                      $scope.Score.createdById = app.Member.Detail.id;


                      // Temps
                      $scope.Score.Temp.tee = $scope.Content.setup.form.tee;
                      $scope.Score.Temp.course = $scope.Content.setup.form.course;
                      $scope.Score.Temp.preferenceSettings.trackStats = $scope.Content.setup.form.trackStats;
                      $scope.Score.Temp.preferenceSettings.postHoleByHole = $scope.Content.setup.form.postHoleByHole;
                      

                      if ($scope.Score.gross == 0) {
                          if (!$scope.Score.Temp.preferenceSettings.postHoleByHole) {
                              $scope.Score.gross = app.Member.Detail.strokesOverPar || 0;

                              if ($scope.Score.gross > 0) {
                                  $scope.Score.gross = Math.round($scope.Score.gross,0) + 72;
                              }
                              if ($scope.Score.gross > 0 && $scope.Score.holesPlayed != app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                                  $scope.Score.gross = Math.round(($scope.Score.gross / 2),0);
                              }
                              if ($scope.Score.gross == 0 && $scope.Score.Temp.course && $scope.Score.Temp.course.tees && $scope.Score.Temp.course.tees.length > 0) {
                                  $scope.Score.gross = $scope.Score.Temp.course.tees[0].par || 0;
                                  if ($scope.Score.gross > 0 && $scope.Score.holesPlayed != app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                                      $scope.Score.gross = Math.round(($scope.Score.gross / 2),0);
                                  }
                              }
                          }
                      }

                      //
                      $scope.f.scoring.saveLocal().then(function () {

                          // Save Favorite Course
                          var processData = function (results) {
                              if (!app.Member.Network.Data.Courses.isFollowing($scope.Score.courseId)) {
                                  app.Member.Network.Data.Courses.follow({ memberId: app.Member.Detail.id, id: $scope.Score.courseId });
                              }
                              $scope.View.tabs.select($scope.View.tabs.types.home);
                          }

                          var isCurrent = ggStorage.get(ggStorage.keys.courses.my.isCurrent);
                          var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.my.data)) || [];

                          if (!storeData || (storeData && storeData.length == 0)) {
                              ggFunctions.toggleProcessing(true);
                              return app.Member.Network.Data.Courses.fetch(true).then(function (data) {
                                  return processData(data);
                              }).finally(function () {
                                  ggFunctions.toggleProcessing(false);
                              });
                          } else {
                              return processData(storeData);
                          }



                      });
                  }
              }
           }
        }

       /*
        -------------------------------
        scoped callbacks
        -------------------------------
        */
        $scope.f = {
            formatScoreObject: function () {

                var scoreTemp = {
                    differential: null
                   , toPar: null
                   , isComplete: false
                   , isChanged: false
                   , course: {}
                   , tee: {}
                   , scoredThru: 0
                   , preferenceSettings : angular.copy(app.Member.Detail.preferenceSettings)
                }

                // Temp object on Game Score so we can destroy it later
                if (!$scope.Score.Temp) {
                    $scope.Score.Temp = scoreTemp;

                    // gap 8.25.2016 - added for hole posting window
                    $scope.Score.Temp.player = {
                        id: -ggStorage.get(ggStorage.keys.member.id),
                        member: {
                            id: ggStorage.get(ggStorage.keys.member.id),
                            firstName: ggStorage.get(ggStorage.keys.member.firstname),
                            lastName: ggStorage.get(ggStorage.keys.member.lastname)
                        }
                    }
                }

                // Stats
                if (!$scope.Score.stats) {
                    var nhs = new app.modules.scoring.objects.scoreStats();
                    $scope.Score.stats = nhs;
                }

                // If Score is not set // First time formatting
                if (!$scope.Temp.isScoreSet) {

                    // Create a local Score object
                    if (!$scope.Score.localScoreId) {
                        $scope.Score.localScoreId = 0;
                    }

                    // Brand New Score
                    if ($scope.Score.id == 0 && (!$scope.Score.localScoreId || $scope.Score.localScoreId == 0)) {

                        // Holes Played
                        $scope.Score.holesPlayed == ggStorage.get(ggStorage.keys.member.prefs.holesPlayed) || app.modules.scoring.constants.holesPlayed.eighteenHoles;

                        // Course & Tees
                        if ($scope.Score.courseId == 0) {
                            $scope.Score.courseId = app.Member.Detail.preferenceSettings.defaultCourseId || 0;
                            $scope.Score.teeId = app.Member.Detail.preferenceSettings.defaultTeeId || 0;
                            $scope.Score.Temp.course = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.course.courseObj)) || {};

                            // Course Name
                            if ($scope.Score.Temp.course && $scope.Score.Temp.course.name) {
                                $scope.Score.courseName = $scope.Score.Temp.course.name;
                            }

                            // Tee object is in course
                            if ($scope.Score.teeId > 0) {
                                if ($scope.Score.Temp.course.tees) {
                                    for (var t = 0; t < $scope.Score.Temp.course.tees.length; t++) {
                                        if ($scope.Score.teeId == $scope.Score.Temp.course.tees[t].id) {
                                            $scope.Score.teeName = $scope.Score.Temp.course.tees[t].name;
                                            $scope.Score.Temp.tee = $scope.Score.Temp.course.tees[t];
                                            break;
                                        }
                                    }
                                }
                            }

                            // Make sure Tee is Sorted.
                            if ($scope.Score.Temp.tee && $scope.Score.Temp.tee.holes) {
                                var aryTee = angular.copy($scope.Score.Temp.tee.holes);
                                aryTee.sort(function (a, b) { return a.number - b.number });
                                $scope.Score.Temp.tee.holes = aryTee;
                            }


                        } else {
                            $scope.Score.courseId = $scope.Score.courseId;
                            $scope.Score.teeId = $scope.Score.teeId;
                            $scope.Score.Temp.course = {};
                        }


                    } else { // Existing Score override defaults

                        // Stats
                        if (
                              ($scope.Score.stats.puttCount && $scope.Score.stats.puttCount > 0)
                           ||
                              ($scope.Score.stats.fairwaysHit && $scope.Score.stats.fairwaysHit > 0)
                           ||
                              ($scope.Score.stats.penaltyStrokes && $scope.Score.stats.penaltyStrokes > 0)
                           ) {
                            $scope.Score.Temp.preferenceSettings.trackStats = true;
                            $scope.Content.setup.form.trackStats = true;

                            // Stats are on.  Any individual overriding?
                            if (!$scope.Score.Temp.preferenceSettings.trackPutting && $scope.Score.stats.puttCount && $scope.Score.stats.puttCount > 0) {
                                $scope.Score.Temp.preferenceSettings.trackPutting = true;
                            }
                            if (!$scope.Score.Temp.preferenceSettings.trackPenalties && $scope.Score.stats.penaltyStrokes && $scope.Score.stats.penaltyStrokes > 0) {
                                $scope.Score.Temp.preferenceSettings.trackPenalties = true;
                            }
                            if (!$scope.Score.Temp.preferenceSettings.trackDriveDistance && $scope.Score.stats.avgDriveDistance && $scope.Score.stats.avgDriveDistance > 0) {
                                $scope.Score.Temp.preferenceSettings.trackDriveDistance = true;
                            }
                            if (!$scope.Score.Temp.preferenceSettings.trackPuttLength && $scope.Score.stats.shortestOnePutt && $scope.Score.stats.shortestOnePutt > 0) {
                                $scope.Score.Temp.preferenceSettings.trackPuttLength = true;
                            }

                        } else {
                            if (!$scope.Score.localScoreId || $scope.Score.localScoreId == 0) {
                                $scope.Score.Temp.preferenceSettings.trackStats = false;
                                $scope.Content.setup.form.trackStats = false;
                            }
                        }

                        // Is HBH // Only Server Scores for this logic?
                        if ($scope.Score.id > 0) {
                            if ($scope.Score.gross > 0 && $scope.Score.holeScores.length == 0) {
                                $scope.Score.Temp.preferenceSettings.postHoleByHole = false;
                                $scope.Content.setup.form.postHoleByHole = false;
                            } else {
                                $scope.Score.Temp.preferenceSettings.postHoleByHole = true;
                                $scope.Content.setup.form.true = false;
                            }
                        }
                    }
                }

                // Check for existing hole scores and populate object w/ 18 records in order
                //if ($scope.Score.Temp.preferenceSettings.postHoleByHole) {
                if (1==1){
                    var aryHoles = angular.copy($scope.Score.holeScores); // save current holes to array
                    var len = aryHoles.length;
                    var hn = 0;

                    var hb = []; // Store current hole numbers
                    if (len > 0) {
                        for (var h = 0; h < len; h++) {
                            hb.push(aryHoles[h].number);
                        }
                    }

                    // Add missing hole objects
                    for (var h = 0; h < 18; h++) {
                        hn++;
                        if (hb.indexOf(hn) == -1) {
                            var holeScore = new app.modules.scoring.objects.holeScore();
                            holeScore.number = hn;
                            aryHoles.push(holeScore);
                        }
                    }

                    // Finally, reorder the holes
                    var arySortedHoles = aryHoles;
                    arySortedHoles.sort(function (a, b) { return a.number - b.number });

                    // Save holes to Score object.
                    $scope.Score.holeScores = arySortedHoles;

                    // Is Score Complete?
                    if ($scope.Score.holesPlayed == app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                        if ($scope.Score.Temp.scoredThru == 18) {
                            $scope.Score.Temp.isComplete = true;
                        }
                    } else {
                        if ($scope.Score.Temp.scoredThru = 9) {
                            $scope.Score.Temp.isComplete = true;
                        }
                    }
                }

                $scope.Temp.isScoreSet = true;
                $scope.f.holdMouseDown();
            }
           , toggleAdvancedSetup: function () {
               $scope.Temp.isAdvancedSetup = !$scope.Temp.isAdvancedSetup
           }
           , closeHoleView: function () {
               ngDialog.closeAll();
               if ($scope.Score.Temp.isChanged) {
                   $scope.f.scoring.saveLocal();
               }
           }

           , getHoleScoreIndex: function (hn) {
               var rn = -1;
               if ($scope.Score.holeScores && $scope.Score.holeScores.length > 0) {
                   for (var h = 0; h < $scope.Score.holeScores.length; h++) {
                       if ($scope.Score.holeScores[h].number == hn) {
                           rn = h;
                           break;
                       }
                   }
               }
               return rn;
           }
           , updateHoleNumber: function (data) {
              if (data && data.value) {
                 if ($scope.f.getHoleScoreIndex(data.value) > -1) {
                    $scope.Score.Temp.currentHoleNumber = Number(data.value);
                 } else {

                     $scope.Score.Temp.currentHoleNumber = 1;

                     // if isComplete , close modal
                     if ($scope.f.scoring.canPublish()) {
                         ngDialog.closeAll();
                     }

                 }
                   
               }
           }
           , getHoleClass: function (holeIndex) {
               var rv = "";
               var holeScore = $scope.Score.holeScores[holeIndex];
               var hole = $scope.Score.Temp.tee.holes[holeIndex];
               if (holeScore && holeScore.gross && hole && hole.par && hole.par > 0) {

                   if (holeScore.gross < (hole.par - 1)) {
                       rv = rv + " eagle";
                   }
                   if (holeScore.gross == (hole.par - 1)) {
                       rv = rv + " birdie";
                   }
                   if (holeScore.gross == (hole.par)) {
                       rv = rv + " par";
                   }
                   if (holeScore.gross == (hole.par + 1)) {
                       rv = rv + " bogey";
                   }
                   if (holeScore.gross == (hole.par + 2)) {
                       rv = rv + " double";
                   }
                   if (holeScore.gross > (hole.par + 2)) {
                       rv = rv + " other";
                   }
               }
               return rv;
           }
           , updatePlayDate: function (data) {
               if (data) {
                   $scope.Content.setup.form.playDate = data.date;
               }
           }
           , updateCourse: function (course, tee) {
               if (course && course.id) {
                   $scope.Content.setup.form.courseId = course.id;
                   $scope.Content.setup.form.course = course;
               }
               if (tee && tee.id) {
                   $scope.Content.setup.form.teeId = tee.id;

                   // Make sure holes are sorted
                   if (tee.holes && tee.holes.length > 0) {
                       var arySortedHoles = tee.holes;
                       arySortedHoles.sort(function (a, b) { return a.number - b.number });
                       tee.holes = arySortedHoles;
                   }
                   $scope.Content.setup.form.tee = tee;
               }

           }
           , updateHoleScore: function (hindex) { // Desktop Entry toggles that item needs to be saved

               $scope.Score.Temp.isChanged = true; // changed global
               $scope.Temp.saveState.changedOn = new Date().getTime();

              // Update gross gross
               var grossgross = 0;
               for (var g = 0; g < $scope.Score.holeScores.length; g++) {
                  if ($scope.Score.holeScores[g].gross) {
                     grossgross = $scope.Score.holeScores[g].gross + grossgross;
                  }
               }
               $scope.Score.gross = grossgross;

               if (hindex == 8 || hindex == 17 || $scope.Score.Temp.scoredThru == 9 || $scope.Score.Temp.scoredThru == 18) {
                   $scope.f.scoring.saveLocal();
               }

           }
           , updateQuickPost: function (v) { // Desktop Entry toggles that item needs to be saved

               var nv = isNaN($scope.Score.gross) ? 0 : Number($scope.Score.gross);
               nv += v;
               $scope.Score.gross = nv;
               $scope.Score.esc = nv;
               $scope.f.scoring.saveLocal();
           }
           , cancelTab: function (e) {
               if (e.keyCode == 9) {
                   e.preventDefault();
               }
           }
           , autoStepScore: function (e, id, holeIndex) {


               var isStep = false;
               var isTab = false;
               var isTypeChange = false;
               var isNumber = false;

               var oldVal = 0;
               var newVal = 0;
               var oldEl = angular.element(document.querySelector("#" + id + "-0-" + holeIndex));
               var nxtHole = holeIndex + 1;

               if (e.keyCode == 9) {
                   isTab = true;
               }
               if (e.keyCode > 47 && e.keyCode < 58) {
                   isNumber = true;
               }

               if (!isTab) {
                   if (id == "score" && isNumber) {
                       oldVal = $scope.Score.holeScores[holeIndex].gross;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           if (newVal > 1) {
                               isStep = true;
                           }
                       }
                   }

                   if (id == "putt" && isNumber) {
                       oldVal = $scope.Score.holeScores[holeIndex].stats.puttCount;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           //if (newVal > 1) {
                           isStep = true;
                           //}
                       }
                   }

                   if (id == "penalty" && isNumber) {
                       oldVal = $scope.Score.holeScores[holeIndex].stats.penaltyStrokes;
                       newVal = oldEl[0].value;
                       if (newVal < ($scope.Temp.maxHoleScore + 1)) {
                           //if (newVal > 1) {
                           isStep = true;
                           //}
                       }
                   }

                   if (id == "drive" && isNumber) {
                       oldVal = $scope.Score.holeScores[holeIndex].stats.driveDistance;
                       newVal = oldEl[0].value;
                       if (newVal > 99) {
                           isStep = true;
                       }
                   }

                   if (id == "firstputt" && isNumber) {
                       oldVal = $scope.Score.holeScores[holeIndex].stats.puttLength;
                       newVal = oldEl[0].value;
                       if (newVal > 10) {
                           isStep = true;
                       }
                   }
               } else {
                   isStep = true;
               }

               if (isStep) {
                   if ((nxtHole == 9 && $scope.Temp.tabIndexType == 9 && $scope.Score.Temp.preferenceSettings.trackStats) || (nxtHole > 17 || (nxtHole == 9 && $scope.Score.holesPlayed == app.modules.scoring.constants.holesPlayed.frontNine))) {
                       isTypeChange = true;
                   }
               }

               if (isTypeChange) {
                   // multiplayer
                   // stats
                   // wagers

                   if ($scope.Temp.tabIndexType == 9 && (nxtHole == 9 || nxtHole > 17)) {
                       // 9 hole tabs
                       if (nxtHole == 9) {
                           nxtHole = 0;
                       } else {
                           if (nxtHole > 17) {
                               nxtHole = 9;
                           }
                       }
                       if (id == "score") {
                           if ($scope.Score.Temp.preferenceSettings.trackStats) {
                               id = "putt";
                               if (!$scope.Score.Temp.preferenceSettings.trackPutting) {
                                   id = "penalty";
                                   if (!$scope.Score.Temp.preferenceSettings.trackPenalties) {
                                       id = "drive";
                                       if (!$scope.Score.Temp.preferenceSettings.trackDriveDistance) {
                                           id = "firstputt";
                                           if (!$scope.Score.Temp.preferenceSettings.trackPuttLength) {
                                               id = "score";
                                               if (nxtHole == 0) {
                                                   nxtHole = 9;
                                               } else {
                                                   if (nxtHole == 9) {
                                                       nxtHole = 0;
                                                   }
                                               }
                                           }
                                       }
                                   }
                               }
                           }
                       } else {
                           if (id == "putt") {
                               id = "penalty";
                               if (!$scope.Score.Temp.preferenceSettings.trackPenalties) {
                                   id = "drive";
                                   if (!$scope.Score.Temp.preferenceSettings.trackDriveDistance) {
                                       id = "firstputt";
                                       if (!$scope.Score.Temp.preferenceSettings.trackPuttLength) {
                                           id = "score";
                                           if (nxtHole == 0) {
                                               nxtHole = 9;
                                           } else {
                                               if (nxtHole == 9) {
                                                   nxtHole = 0;
                                               }
                                           }
                                       }
                                   }
                               }
                           } else {
                               if (id == "penalty") {
                                   id = "drive";
                                   if (!$scope.Score.Temp.preferenceSettings.trackDriveDistance) {
                                       id = "firstputt";
                                       if (!$scope.Score.Temp.preferenceSettings.trackPuttLength) {
                                           id = "score";
                                           if (nxtHole == 0) {
                                               nxtHole = 9;
                                           } else {
                                               if (nxtHole == 9) {
                                                   nxtHole = 0;
                                               }
                                           }
                                       }
                                   }
                               } else {
                                   if (id == "drive") {
                                       id = "firstputt";
                                       if (!$scope.Score.Temp.preferenceSettings.trackPuttLength) {
                                           id = "score";
                                           if (nxtHole == 0) {
                                               nxtHole = 9;
                                           } else {
                                               if (nxtHole == 9) {
                                                   nxtHole = 0;
                                               }
                                           }
                                       }
                                   } else {
                                       id = "score";
                                       if (nxtHole == 0) {
                                           nxtHole = 9;
                                       } else {
                                           if (nxtHole == 9) {
                                               nxtHole = 0;
                                           }
                                       }
                                   }
                               }
                           }
                       }
                   }
               }


               if (isStep || isTypeChange) {
                   var newEl = angular.element(document.querySelector("#" + id + "-0-" + nxtHole));

                   // Drives disabled on par 3
                   if (newEl[0].isDisabled) {
                       nxtHole++;
                       if (nxtHole > 17) {
                           nxtHole == 0;
                       }
                       newEl = angular.element(document.querySelector("#" + id + "-0-" + nxtHole));
                   }

                   $scope.Score.Temp.currentHoleNumber = nxtHole + 1;
                   newEl[0].select();
               }


           }
            // HoleView Update Callbacks
           , updateHoleGross: function (data) {

               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (isNaN(vl) || vl == "") {
                   vl = 0
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].gross) {
                   $scope.Score.holeScores[hindex].gross = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }
           , updateHolePutts: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if ((isNaN(vl) || vl == "") && vl != 0) {
                   vl = null;
               } else {
                   vl = Number(vl);
               }
               if (vl < 0) {
                  vl = null;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].stats.puttCount) {
                   $scope.Score.holeScores[hindex].stats.puttCount = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }
           , updateHolePenalties: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }
               if (vl < 0) {
                  vl = null;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].stats.penaltyStrokes) {
                   $scope.Score.holeScores[hindex].stats.penaltyStrokes = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }
           , updateHoleClub: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (vl && vl != "") {
                   vl = vl;
               } else {
                   vl = null
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].stats.golfClub) {
                   $scope.Score.holeScores[hindex].stats.golfClub = vl;
                   $scope.f.updateHoleScore(hindex);
               }
           }
           , updateHoleDrive: function () {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl && vl != $scope.Score.holeScores[hindex].stats.driveDistance) {
                   $scope.Score.holeScores[hindex].stats.driveDistance = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }
           , updateHoleFIR: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (!vl || vl == "") {
                   vl = null;
               } else {
                   vl = vl;
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].stats.fir) {
                   $scope.Score.holeScores[hindex].stats.fir = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }
           , updateHoleUpDown: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);

               vl = Number(vl);

               var isChanged = false;
               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl > 0) {
                   if (vl == 1) {
                       // No Value
                       if ($scope.Score.holeScores[hindex].stats.upAndDownOpportunity) {
                           $scope.Score.holeScores[hindex].stats.upAndDownOpportunity = null;
                           isChanged = true;
                       }
                       if ($scope.Score.holeScores[hindex].stats.upAndDownHit) {
                           $scope.Score.holeScores[hindex].stats.upAndDownHit = null;
                           isChanged = true;
                       }
                   } else {
                       // Opportunity
                       if (!$scope.Score.holeScores[hindex].stats.upAndDownOpportunity) {
                           $scope.Score.holeScores[hindex].stats.upAndDownOpportunity = true;
                           isChanged = true;
                       }
                       if (vl == 2) {
                           // Hit
                           if (!$scope.Score.holeScores[hindex].stats.upAndDownHit) {
                               $scope.Score.holeScores[hindex].stats.upAndDownHit = true;
                               isChanged = true;
                           }
                       } else {
                           // Missed
                           if ($scope.Score.holeScores[hindex].stats.upAndDownHit) {
                               $scope.Score.holeScores[hindex].stats.upAndDownHit = false;
                               isChanged = true;
                           }
                       }
                   }
               }

               if (isChanged) {
                   $scope.f.updateHoleScore(hindex);
               }




           }
           , updateHoleSandie: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);

               vl = Number(vl);

               var isChanged = false;
               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl > 0) {
                   if (vl == 1) {
                       // No Value
                       if ($scope.Score.holeScores[hindex].stats.sandSaveOpportunity) {
                           $scope.Score.holeScores[hindex].stats.sandSaveOpportunity = null;
                           isChanged = true;
                       }
                       if ($scope.Score.holeScores[hindex].stats.sandSaveHit) {
                           $scope.Score.holeScores[hindex].stats.sandSaveHit = null;
                           isChanged = true;
                       }
                   } else {
                       // Opportunity
                       if (!$scope.Score.holeScores[hindex].stats.sandSaveOpportunity) {
                           $scope.Score.holeScores[hindex].stats.sandSaveOpportunity = true;
                           isChanged = true;
                       }
                       if (vl == 2) {
                           // Hit
                           if (!$scope.Score.holeScores[hindex].stats.sandSaveHit) {
                               $scope.Score.holeScores[hindex].stats.sandSaveHit = true;
                               isChanged = true;
                           }
                       } else {
                           // Missed
                           if ($scope.Score.holeScores[hindex].stats.sandSaveHit) {
                               $scope.Score.holeScores[hindex].stats.sandSaveHit = false;
                               isChanged = true;
                           }
                       }
                   }
               }

               if (isChanged) {
                   $scope.f.updateHoleScore(hindex);
               }
           }
           , updateHoleFirstPutt: function (data) {
               // HoleNmber, Par, Selected
               var hn = Number(data.holeNumber);
               var vl = data.value;
               var pr = Number(data.par);
               if (isNaN(vl) || vl == "") {
                   vl = null;
               } else {
                   vl = Number(vl);
               }

               var hindex = $scope.f.getHoleScoreIndex(hn);
               if (vl != $scope.Score.holeScores[hindex].stats.puttLength) {
                   $scope.Score.holeScores[hindex].stats.puttLength = vl;
                   $scope.f.updateHoleScore(hindex);
               }


           }

           , format: {
               playDate: function (d) {
                   return ggFunctions.formatDateString(d, "m/d/yyyy", null);
               }
              , number: function (n, d) {
                  if (isNaN(n)) {
                      n = 0;
                  }
                  if (isNaN(d)) {
                      d = 0;
                  }

                  n = Math.round(n, d);

                  return n;
              }
              , percent: function (n) {
                  if (isNaN(n)) {
                      n = 0;
                  } else {
                      n = (n * 100);
                  }

                  n = Math.round(n, 1) + "%"
                  return n;
              }
           }

           , scoring: {
               openHoleView: function (hn) {

                   // Need these items in the Hole View
                   $scope.Score.Temp.currentHoleNumber = hn ||1;

                   // List of Pars
                   $scope.Temp.holes.par = [];
                   for (var p = 0; p < $scope.Score.Temp.tee.holes.length; p++) {
                       $scope.Temp.holes.par.push($scope.Score.Temp.tee.holes[p].par);
                   }

                   app.Member.Session.pageTemplates.fetch(app.modules.scoring.routes.scoreholeview.templateUrl).then(function (template) {

                      var _holeViewModal = ngDialog.open({
                         template: template
                         , plain: true
                         , closeByEscape: false
                         , closeByDocument: false
                         , showClose: true
                         , className: "holeview"
                         , scope: $scope
                      });


                   });

               }
              , canPublish: function () {
                  var rv = false;
                  if ($scope.Score && $scope.Score.localScoreId && $scope.Score.localScoreId > 0) {
                      if (
                         ($scope.Score.Temp.scoredThru == 18 && $scope.Score.holesPlayed == app.modules.scoring.constants.holesPlayed.eighteenHoles)
                         ||
                         ($scope.Score.Temp.scoredThru == 9 && $scope.Score.holesPlayed != app.modules.scoring.constants.holesPlayed.eighteenHoles)
                         ||
                         ($scope.Score.gross > 0 && !$scope.Score.Temp.preferenceSettings.postHoleByHole)
                       ) {
                          rv = true;
                      }
                  }
                  return rv;
              }
              , saveLocal: function () {
                  // gap 8.25.2016 - $scope.f.formatScoreObject();
                  return $scope.f.scoring.preProcessHoleScores().then(function () {
                      // This Saves a Local Score // But if all data is copacetic // send to the server and purge from localScore
                      if ($scope.Score.localScoreId) {

                          var localScores = ggStorage.get(ggStorage.keys.scoring.inProgress.data);
                          var ls = [];
                          if (localScores) {
                              ls = JSON.parse(localScores);
                              if (ls) {

                                  for (var l = 0; l < ls.length; l++) {
                                      if (ls[l].localScoreId == $scope.Score.localScoreId) {
                                          ls[l] = $scope.Score;
                                          break;
                                      }
                                  }
                                  ggStorage.set(ggStorage.keys.scoring.inProgress.data, ls);
                              }
                          }
                      } else {

                          //if (Score.gross > 0) {
                          var localScores = ggStorage.get(ggStorage.keys.scoring.inProgress.data);
                          var localScoreId = 1;
                          var ls = [];
                          if (localScores) {
                              ls = JSON.parse(localScores);
                              if (ls) {

                                  for (var l = 0; l < ls.length; l++) {
                                      if (ls[l].localScoreId >= localScoreId) {
                                          localScoreId = ls[l].localScoreId + 1;
                                      }
                                  }

                              }
                          }

                          $scope.Score.localScoreId = localScoreId;
                          ls.push($scope.Score);

                          ggStorage.set(ggStorage.keys.scoring.inProgress.data, ls);
                          //}
                      }

                      $scope.Score.Temp.isChanged = false;
                      return $q.resolve();
                  });

              }
              , deleteScore: function () {

                  /*
                  var btnA = new ggAlertSvc.button;
                  btnA.name = "OK"
                  btnA.path = ""
                  btnA.callback = function () {
                      if ($scope.Score.localScoreId > 0) {

                          var localScores = ggStorage.get(ggStorage.keys.scoring.inProgress.data);
                          var ls = JSON.parse(localScores);
                          if (ls) {

                              for (var l = 0; l < ls.length; l++) {
                                  if (ls[l].localScoreId == $scope.Score.localScoreId) {
                                      ls.splice(l, 1);
                                      ggStorage.set(ggStorage.keys.scoring.inProgress.data, ls);
                                      ggFunctions.goToPage(app.modules.view.routes.intro.path);
                                      break;
                                  }
                              }
                          }

                      }
                  }

                  var btnB = new ggAlertSvc.button;
                  btnB.name = "Cancel"
                  btnB.path = ""

                  $scope.PopupAlert.warn("Are you sure?", "This action will delete the score from your local device.", [btnA, btnB]);
                  */

                  // Only deleete from home page now
                  ggFunctions.goToPage(app.modules.view.routes.intro.path);


              }
              , clickSaveScore: function (isBackgroundProcess) { // Button to Save All Scores

                  $scope.Temp.saveState.saving = true;

                  var nd = new Date();

                  // update each score / hole stat 
                  // gap 8.25.2016 - $scope.f.formatScoreObject();
                  $scope.f.scoring.preProcessHoleScores().then(function () {

                      // Send the data to the API
                      var save = function () {
                          return $scope.f.scoring.saveFullScore();
                      }

                      // Show processor
                      if (!isBackgroundProcess) {
                          ggFunctions.toggleProcessing(true);
                      }

                      save().finally(function () {
                          ggFunctions.toggleProcessing(false);
                          $scope.Temp.saveState.saving = false;
                          $scope.Temp.saveState.savedOn = new Date().getTime();
                      });

                  });


              }
              , preProcessHoleScores: function () { // Recalc each stat for a score
                  return $q(function (resolve) {

                      var score = {
                          gross: 0
                          //, net: 0
                          // , front9Gross: 0
                          // , back9Gross: 0
                          // , front9Net: 0
                          // , back9Net: 0
                         , toPar: 0
                         , differential: 0
                      }
                      var stats = {
                          puttCount: null //x
                         , shortestOnePutt: null //x
                         , longestOnePutt: null //x
                         , gir: null //x
                         , longDriveDistance: null //x
                         , avgDriveDistance: null //x
                         , fairwayOpportunities: null //x
                         , fairwaysHit: null //x
                         , fairwaysMissed: null //x
                         , fairwaysMissedLeft: null //x
                         , fairwaysMissedRight: null //x
                         , fairwaysMissedShort: null //x
                         , fairwaysMissedLong: null //x
                         , fairwayChips: null
                         , upAndDownOpportunities: null //x
                         , upAndDownsHit: null //x
                         , sandSaveOpportunities: null //x
                         , sandSavesHit: null //x
                         , bounceBackOpportunities: null//x
                         , bounceBacksHit: null//x
                         , scrambleOpportunities: null //x
                         , scramblesHit: null //x
                         , callawayScore: null
                         , callawayHandicap: null
                         , holeInOneCount: null//x
                         , albatrossCount: null//x
                         , eagleCount: null//x
                         , birdieCount: null//x
                         , parCount: null//x
                         , bogeyCount: null//x
                         , doubleCount: null//x
                         , overDoubleCount: null//x
                         , par3Count: null //x
                         , par4Count: null //x
                         , par5Count: null //x
                         , par3Score: null //x
                         , par4Score: null //x
                         , par5Score: null //x
                         , penaltyStrokes: null //x
                         , exceptionalScoreOdds: null
                      }
                      var sum = {
                          loops: 0
                         , holesPlayed: 0
                         , driveDistance: 0
                         , driveCount: 0
                      }

                      if ($scope.Score.Temp.preferenceSettings.postHoleByHole && $scope.Score.Temp.tee && $scope.Score.Temp.tee.holes && $scope.Score.Temp.tee.holes.length > 0) {

                          for (var x = 0; x < 18; x++) {
                              var isok = false;
                              if (x < 9) {
                                  if ($scope.Score.holesPlayed != app.modules.scoring.constants.holesPlayed.backNine) {
                                      isok = true;
                                  }
                              } else {
                                  if ($scope.Score.holesPlayed != app.modules.scoring.constants.holesPlayed.frontNine) {
                                      isok = true;
                                  }
                              }

                              if (isok) {

                                  // loop count
                                  sum.loops++;

                                  // holes played 
                                  if (Number($scope.Score.holeScores[x].gross) > 0) {
                                      sum.holesPlayed++;
                                  }

                                  var total = 0;

                                  // gross
                                  total = Number(score.gross) + (Number($scope.Score.holeScores[x].gross));
                                  score.gross = total;
                                  //score.net = total;
                                  $scope.Score.gross = score.gross;
                                  //$scope.Score.net = score.net;

                                  // To Par
                                  total = Number(score.toPar) + (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par));
                                  score.toPar = total;
                                  $scope.Score.Temp.toPar = score.toPar;

                                  // Scoring
                                  if (Number($scope.Score.holeScores[x].gross) > 0) {
                                      $scope.Score.holeScores[x].esc = $scope.Score.holeScores[x].gross; // API will handle this
                                      // Hole In One
                                      if (Number($scope.Score.holeScores[x].gross) == 1) {
                                          stats.holeInOneCount = Number(stats.holeInOneCount) + 1;
                                      }

                                      if (Number($scope.Score.Temp.tee.holes[x].par) > 0) {
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == -3) {
                                              stats.albatrossCount = Number(stats.albatrossCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == -2) {
                                              stats.eagleCount = Number(stats.eagleCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == -1) {
                                              stats.birdieCount = Number(stats.birdieCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == 0) {
                                              stats.parCount = Number(stats.parCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == 1) {
                                              stats.bogeyCount = Number(stats.bogeyCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) == 2) {
                                              stats.doubleCount = Number(stats.doubleCount) + 1;
                                          }
                                          if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) > 2) {
                                              stats.overDoubleCount = Number(stats.overDoubleCount) + 1;
                                          }
                                      }
                                      if (Number($scope.Score.Temp.tee.holes[x].par) == 3) {
                                          stats.par3Count = Number(stats.par3Count) + 1;
                                          stats.par3Score = Number(stats.par3Score) + Number($scope.Score.holeScores[x].gross);
                                      }
                                      if (Number($scope.Score.Temp.tee.holes[x].par) == 4) {
                                          stats.par4Count = Number(stats.par4Count) + 1;
                                          stats.par4Score = Number(stats.par4Score) + Number($scope.Score.holeScores[x].gross);
                                      }
                                      if (Number($scope.Score.Temp.tee.holes[x].par) == 5) {
                                          stats.par5Count = Number(stats.par5Count) + 1;
                                          stats.par5Score = Number(stats.par5Score) + Number($scope.Score.holeScores[x].gross);
                                      }


                                  }


                                  // Callaway Scoring
                                  if (Number($scope.Score.holeScores[x].gross) > 0 && Number($scope.Score.Temp.tee.holes[x].par) > 0) {
                                      $scope.Score.holeScores[x].stats.callawayScore = Number($scope.Score.holeScores[x].gross);
                                      // max gross is double par
                                      if (Number($scope.Score.holeScores[x].gross) > Number($scope.Score.Temp.tee.holes[x].par) * 2) {
                                          $scope.Score.holeScores[x].stats.callawayScore = Number($scope.Score.Temp.tee.holes[x].par) * 2;
                                      }
                                      total = Number(stats.callawayScore) + Number($scope.Score.holeScores[x].stats.callawayScore);
                                      stats.callawayScore = (total == 0 ? null : total);
                                  }

                                  // Putts
                                  total = Number(stats.puttCount) + Number($scope.Score.holeScores[x].stats.puttCount);
                                  stats.puttCount = (total == 0 ? null : total);

                                  // Shortest & Longest Putts
                                  if (Number($scope.Score.holeScores[x].stats.puttCount) == 1) {
                                      if (Number($scope.Score.holeScores[x].stats.puttLength) > 0) {
                                          if (Number(stats.shortestOnePutt) == 0) {
                                              stats.shortestOnePutt = Number($scope.Score.holeScores[x].stats.puttLength);
                                          } else {
                                              if (stats.shortestOnePutt > Number($scope.Score.holeScores[x].stats.puttLength)) {
                                                  stats.shortestOnePutt = Number($scope.Score.holeScores[x].stats.puttLength);
                                              }
                                          }
                                          if (Number(stats.longestOnePutt) == 0) {
                                              stats.longestOnePutt = Number($scope.Score.holeScores[x].stats.puttLength);
                                          } else {
                                              if (stats.longestOnePutt < Number($scope.Score.holeScores[x].stats.puttLength)) {
                                                  stats.longestOnePutt = Number($scope.Score.holeScores[x].stats.puttLength);
                                              }
                                          }
                                      }
                                  }

                                  // GIR = Par - Putts < par -2;
                                  $scope.Score.holeScores[x].stats.gir = null;
                                  if (Number($scope.Score.holeScores[x].gross) > 0 && Number($scope.Score.holeScores[x].stats.puttCount) > 0 && Number($scope.Score.Temp.tee.holes[x].par) > 0) {
                                      total = (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.holeScores[x].stats.puttCount)) < Number($scope.Score.Temp.tee.holes[x].par) - 2 ? 1 : 0;
                                      if (total > 0) {
                                          stats.gir = Number(stats.gir) + 1;
                                          $scope.Score.holeScores[x].stats.gir = true;
                                      } else {
                                          $scope.Score.holeScores[x].stats.gir = false;
                                      }
                                  }

                                  // PenaltyStrokes 0's not allowed, reset to null
                                  if (!isNaN($scope.Score.holeScores[x].stats.penaltyStrokes)) {
                                      total = Number(stats.penaltyStrokes) + Number($scope.Score.holeScores[x].stats.penaltyStrokes);
                                      stats.penaltyStrokes = (total == 0 ? null : total);
                                  }
                                  // Long Drive
                                  if (Number($scope.Score.holeScores[x].stats.driveDistance) > 0) {
                                      sum.driveDistance = Number($scope.Score.holeScores[x].stats.driveDistance);
                                      sum.driveCount++;

                                      if (Number($scope.Score.holeScores[x].stats.driveDistance) > Number(stats.longDriveDistance)) {
                                          stats.longDriveDistance = Number($scope.Score.holeScores[x].stats.driveDistance);
                                      }
                                  }

                                  // Fairway Opps
                                  total = Number(stats.fairwayOpportunities) + ($scope.Score.holeScores[x].stats.fir || $scope.Score.holeScores[x].stats.fir != app.modules.scoring.constants.fairwayHitType.noOpportunity ? 1 : 0);
                                  stats.fairwayOpportunities = (total == 0 ? null : total);

                                  // Fairway Hit
                                  total = Number(stats.fairwaysHit) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.hit ? 1 : 0);
                                  stats.fairwaysHit = (total == 0 ? null : total);

                                  // Fairway Missed
                                  total = Number(stats.fairwaysMissed) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missed ? 1 : 0);
                                  stats.fairwaysMissed = (total == 0 ? null : total);

                                  // Fairway Missed Left
                                  total = Number(stats.fairwaysMissedLeft) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedLeft ? 1 : 0);
                                  stats.fairwaysMissedLeft = (total == 0 ? null : total);

                                  // Fairway Missed Right
                                  total = Number(stats.fairwaysMissedRight) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedRight ? 1 : 0);
                                  stats.fairwaysMissedRight = (total == 0 ? null : total);

                                  // Fairway Missed Short
                                  total = Number(stats.fairwaysMissedShort) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedShort ? 1 : 0);
                                  stats.fairwaysMissedShort = (total == 0 ? null : total);

                                  // Fairway Missed Long
                                  total = Number(stats.fairwaysMissedLong) + ($scope.Score.holeScores[x].stats.fir == app.modules.scoring.constants.fairwayHitType.missedLong ? 1 : 0);
                                  stats.fairwaysMissedLong = (total == 0 ? null : total);

                                  // Up & Down Opps
                                  total = Number(stats.upAndDownOpportunities) + ($scope.Score.holeScores[x].stats.upAndDownOpportunity ? 1 : 0);
                                  stats.upAndDownOpportunities = (total == 0 ? null : total);

                                  // Up & Down Hit
                                  total = Number(stats.upAndDownsHit) + ($scope.Score.holeScores[x].stats.upAndDownHit ? 1 : 0);
                                  stats.upAndDownsHit = (total == 0 ? null : total);

                                  // Sandy Opps
                                  total = Number(stats.sandSaveOpportunities) + ($scope.Score.holeScores[x].stats.sandSaveOpportunity ? 1 : 0);
                                  stats.sandSaveOpportunities = (total == 0 ? null : total);

                                  // Sandy Hit
                                  total = Number(stats.sandSavesHit) + ($scope.Score.holeScores[x].stats.sandSaveHit ? 1 : 0);
                                  stats.sandSavesHit = (total == 0 ? null : total);

                                  // Scrambling - Par or better w/o a GIR
                                  $scope.Score.holeScores[x].stats.scrambleOpportunity = null;
                                  $scope.Score.holeScores[x].stats.scrambleHit = null;
                                  if (Number($scope.Score.holeScores[x].gross) > 0 && Number($scope.Score.holeScores[x].stats.puttCount) > 0 && Number($scope.Score.Temp.tee.holes[x].par) > 0) {
                                      total = (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.holeScores[x].stats.puttCount)) < Number($scope.Score.Temp.tee.holes[x].par) - 2 ? 1 : 0;
                                      if (total < 1) { // NO GIR -- Opportunity is on the green under par.  But no GIR
                                          stats.scrambleOpportunities = Number(stats.scrambleOpportunities) + 1;
                                          $scope.Score.holeScores[x].stats.scrambleOpportunity = true;
                                          if (Number($scope.Score.holeScores[x].gross) < Number($scope.Score.Temp.tee.holes[x].par) + 1) {
                                              stats.scramblesHit = Number(stats.scramblesHit) + 1;
                                              $scope.Score.holeScores[x].stats.scrambleHit = true;
                                          }
                                      }
                                  }

                                  // Bounce Backs - Hole after Bogey or worse, and score a par or better
                                  if (sum.loops > 1) {
                                      $scope.Score.holeScores[x].stats.bounceBackOpportunity = null;
                                      $scope.Score.holeScores[x].stats.bounceBackHit = null;
                                      if (Number($scope.Score.holeScores[x].gross) > 0 && Number($scope.Score.Temp.tee.holes[x].par) > 0) { // Score on current hole
                                          if (Number($scope.Score.holeScores[x - 1].gross) > 0 && Number($scope.Score.Temp.tee.holes[x - 1].par) > 0) { // Score on Previous Hole
                                              if (Number($scope.Score.holeScores[x - 1].gross) - Number($scope.Score.Temp.tee.holes[x - 1].par) > 0) { // Bogey or worse on previous hole
                                                  stats.bounceBackOpportunities = Number(stats.bounceBackOpportunities) + 1;
                                                  $scope.Score.holeScores[x].stats.bounceBackOpportunity = true;
                                                  if (Number($scope.Score.holeScores[x].gross) - Number($scope.Score.Temp.tee.holes[x].par) < 1) {
                                                      stats.bounceBacksHit = Number(stats.bounceBacksHit) + 1;
                                                      $scope.Score.holeScores[x].stats.bounceBackHit = true;
                                                  }
                                              }
                                          }
                                      }
                                  }
                                  var b = 1;

                              }
                          }

                          // Average Drive
                          if (Number(sum.driveCount) > 0 && Number(sum.driveDistance) > 0) {
                              stats.avgDriveDistance = (Number(sum.driveDistance) / Number(sum.driveCount)).toFixed(0);
                          }

                          // Differential
                          var tmpScr = score.gross;
                          // Hack a Partial Differential by getting the avg. hole score and multiplying that times 18,9;
                          if ((sum.holesPlayed < 18 && $scope.Score.holesPlayed == app.modules.scoring.constants.holesPlayed.eighteenHoles) || sum.holesPlayed < 9) {
                              if ($scope.Score.holesPlayed == app.modules.scoring.constants.holesPlayed.eighteenHoles) {
                                  tmpScr = (tmpScr / sum.holesPlayed) * 18;
                              } else {
                                  tmpScr = (tmpScr / sum.holesPlayed) * 9;
                              }
                          }

                          // Callaway Score
                          var callawayHandicap = app.modules.scoring.functions.fetchCallawayHandicap($scope.Score.Temp.tee.par, stats.callawayScore);
                          var callawayAdjustment = app.modules.scoring.functions.fetchCallawayAdjustment($scope.Score.Temp.tee.par, stats.callawayScore);

                          if (callawayHandicap > 0) {
                              // handicap based on the worst holes, so we need to sort the hole scores from worst to best.
                              // except 16, 17, 18
                              var cscores = [];
                              for (var c = 0; c < 15; c++) {
                                  cscores[c] = $scope.Score.holeScores[c].stats.callawayScore;
                              }
                              cscores.sort(function (a, b) { return b - a });

                              // get add up worst scores
                              var worst = 0;
                              if (callawayHandicap == 5) {
                                  worst = Math.round(cscores[0] / 2);
                              }
                              if (callawayHandicap == 10) {
                                  worst = cscores[0];
                              }
                              if (callawayHandicap == 15) {
                                  worst = cscores[0] + Math.round(cscores[1] / 2);
                              }
                              if (callawayHandicap == 20) {
                                  worst = cscores[0] + cscores[1];
                              }
                              if (callawayHandicap == 25) {
                                  worst = cscores[0] + cscores[1] + Math.round(cscores[2] / 2);
                              }
                              if (callawayHandicap == 30) {
                                  worst = cscores[0] + cscores[1] + cscores[2];
                              }
                              if (callawayHandicap == 35) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + Math.round(cscores[3] / 2);
                              }
                              if (callawayHandicap == 40) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3];
                              }
                              if (callawayHandicap == 45) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + Math.round(cscores[4] / 2);
                              }
                              if (callawayHandicap == 50) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4];
                              }
                              if (callawayHandicap == 55) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4] + Math.round(cscores[5] / 2);
                              }
                              if (callawayHandicap == 60) {
                                  worst = cscores[0] + cscores[1] + cscores[2] + cscores[3] + cscores[4] + cscores[5];
                              }

                              // Add adustment
                              stats.callawayHandicap = worst + callawayAdjustment;
                              stats.callawayScore = stats.callawayScore - stats.callawayHandicap;

                          } else {
                              stats.callawayHandicap = 0;
                          }


                          // Update Diff
                          $scope.Score.Temp.differential = ggFunctions.calcDifferential(tmpScr, $scope.Score.rating, $scope.Score.slope);

                          // Apply Score
                          $scope.Score.gross = score.gross;
                          $scope.Score.esc = score.gross; // the api will handle

                          // Scored Thru
                          $scope.Score.Temp.scoredThru = sum.holesPlayed;

                          // Apply Stats
                          $scope.Score.stats = stats;


                      } else {
                          $scope.Score.esc = $scope.Score.gross;
                      }
                      resolve();
                  });
              }
              , saveFullScore: function () {
                  return $q(function (resolve) {

                      var temp = $scope.Temp;
                      var lsId = $scope.Score.localScoreId;

                      // Post Process Score after it has been sent to API
                      var postProcessSavedScore = function (data) {
                          if (data && data.status == "200") {

                              $scope.Temp.saveState.isSaved = true;

                              var updated = data.data;

                              updated.localScoreId = lsId;
                              updated.Temp = temp;
                              $scope.Score = updated;

                              // Remove Local Score 
                              var localScores = JSON.parse(ggStorage.get(ggStorage.keys.scoring.inProgress.data)) || [];
                              if (localScores) {

                                  for (var l = 0; l < localScores.length; l++) {
                                      if (localScores[l].localScoreId == lsId) {
                                          localScores.splice(l, 1);
                                          ggStorage.set(ggStorage.keys.scoring.inProgress.data, localScores);
                                          break;
                                      }
                                  }
                              }


                              ggStorage.set(ggStorage.keys.scoring.recent.isCurrent, false);

                              var btn1 = new ggAlertSvc.button;
                              btn1.name = "Continue";
                              btn1.path = app.modules.view.routes.intro.path;

                              var btn2 = new ggAlertSvc.button;
                              btn2.name = "Post Another";
                              btn2.callback = function () {
                                  $scope.Score.id = 0;
                              };

                              $scope.PopupAlert.success("Published", "The score has been saved to your account.", [btn1])

                          } else {
                              $scope.PopupAlert.warn("Error", "There was an error publishing the score.")
                          }
                      }

                      // Send Score to API
                      var sendScoreToAPI = function (data) {
                          ggFunctions.toggleProcessing(true);
                          return ggScoringSvc.scoring.batchScore(data).then(function (data) {
                              postProcessSavedScore(data);
                          }, function (fail) {
                              var error = fail.data.error.message;
                              if (fail.data.error.innererror && fail.data.error.innererror.message) {
                                  error = fail.data.error.innererror.message;
                              }
                              $scope.PopupAlert.warn("Error", "There was an error publishing the score: " + error);
                              return;
                          }).finally(function () {
                              ggFunctions.toggleProcessing(false);
                          });
                      }

                      var score = angular.copy($scope.Score);
                      if (score.id == 0) {
                          delete score.id;
                      }
                      if (score.Temp) {
                          temp = $scope.Score.Temp;
                          delete score.Temp;
                      }
                      if (score.localScoreId) {
                          lsId = $scope.Score.localScoreId;
                          delete score.localScoreId;
                      }
                      // holeScores
                      if (!$scope.Score.Temp.preferenceSettings.postHoleByHole && score.holeScores) {
                          delete score.holeScores;
                      }

                      // F9 B9
                      if ($scope.Score.Temp.preferenceSettings.postHoleByHole) {
                          if (score.holesPlayed == app.modules.scoring.constants.holesPlayed.frontNine) {
                              var fnHoleScores = []; //angular.copy(score.holeScores);
                              for (var fn = 0; fn < score.holeScores.length; fn++) {
                                  if (score.holeScores[fn].number < 10) {
                                      fnHoleScores.push(score.holeScores[fn]);
                                  }
                              }
                              score.holeScores = fnHoleScores;
                          }
                          if (score.holesPlayed == app.modules.scoring.constants.holesPlayed.backNine) {
                              var bnHoleScores = []; //angular.copy(score.holeScores);
                              for (var bn = 0; bn < score.holeScores.length; bn++) {
                                  if (score.holeScores[bn].number > 9) {
                                      bnHoleScores.push(score.holeScores[bn]);
                                  }
                              }
                              score.holeScores = bnHoleScores;
                          }
                      }


                      // Remove odata junk
                      if (score["@odata.context"]) {
                          delete score["@odata.context"];
                      }

                      return sendScoreToAPI(score).then(function () {
                          resolve();
                      });

                  });
              }
           }
           , holdMouseDown: function () {

                var qpMinus = angular.element(document.querySelector('#qpMinus'));
                var qpPlus  = angular.element(document.querySelector('#qpPlus'));
                var timeout;
                var stopAction = function () {
                    if (timeout) {
                        $timeout.cancel(timeout);
                        timeout = undefined;
                    }
                    if (mouseInterval) {
                        $interval.cancel(mouseInterval);
                        mouseInterval = undefined;
                    }
                };

                var quickPost = function (x) {
                    mouseInterval = $interval(function () {
                        $scope.f.updateQuickPost(x);
                    }, 100);
                }

                qpMinus.on('mousedown', function (event) {
                    stopAction();
                    quickPost(-1);
                    $document.on('mouseup', stopAction);
                    qpMinus.on('mouseout', stopAction);
                });
                qpPlus.on('mousedown', function (event) {
                    stopAction();
                    quickPost(1);
                    $document.on('mouseup', stopAction);
                    qpPlus.on('mouseout', stopAction);
                });
                qpMinus.on('touchstart', function (event) {
                    stopAction();
                    quickPost(-1);
                    $document.on('touchmove', stopAction);
                    $document.on('touchend', stopAction);
                    $document.on('touchcancel', stopAction);
                });
                qpPlus.on('touchstart', function (event) {
                    stopAction();
                    quickPost(1);
                    $document.on('touchmove', stopAction);
                    $document.on('touchend', stopAction);
                    $document.on('touchcancel', stopAction);
                });

            }
        }



        /*
        -------------------------------
        Page Request
        -------------------------------
        */

        if ($routeParams) {

            // Page Request
            var scoreId = 0;
            var localScoreId = 0;
            var isSetup = false;


            var score = {
                id: 0
               , memberId: app.Member.Detail.id
               , playDate: null
               , courseName: ""
               , courseId: 0
               , teeId: 0
               , teeName: ""
               , rating: 71.2
               , slope: 113
               , holesPlayed: app.modules.scoring.constants.holesPlayed.eighteenHoles
               , scoreType: app.modules.scoring.constants.scoreType.away
               , isPlayedAlone: false
               , isHandicapScore: true
               , isPlayedWithClubMember: true
               , gross: 0
               , esc: 0
               , holeScores: []
               , stats: {}
               , attestorId: null
               , attestorName: null
               , createdById: app.Member.Detail.id
            }

            var Temp = {};

            if ($routeParams.localScoreId) {
                localScoreId = Number($routeParams.localScoreId);
            } else {
                if ($routeParams.scoreId) {
                    scoreId = Number($routeParams.scoreId);
                } else {
                    if ($routeParams.playDate) {
                        score.playDate = $routeParams.playDate;
                    }
                    if ($routeParams.courseId) {
                        score.courseId = Number($routeParams.courseId);
                    }
                    if ($routeParams.teeId) {
                        score.teeId = Number($routeParams.teeId);
                    }
                }
            }

            var fetchLocalScore = function (id) {
                if (id && id > 0) {
                    var localScores = ggStorage.get(ggStorage.keys.scoring.inProgress.data);
                    if (localScores) {
                        var ls = JSON.parse(localScores);
                        if (ls) {

                            for (var l = 0; l < ls.length; l++) {
                                if (ls[l].localScoreId == id) {
                                    score = ls[l];
                                    isSetup = true;

                                    if (score.Temp && score.Temp.preferenceSettings) {
                                        $scope.Content.setup.form.postHoleByHole = score.Temp.preferenceSettings.postHoleByHole;
                                        $scope.Content.setup.form.trackStats = score.Temp.preferenceSettings.trackStats;
                                    }

                                    break;
                                }
                            }
                        }
                    }
                }
                return $q.resolve()
            }
            var fetchServerScore = function (scoreId) {
                if (scoreId && scoreId > 0) {
                    return ggScoringSvc.scoring.fetchScore({ scoreId: scoreId }).then(function (data) {
                        if (data && data.status == "200") {
                            score = data.data;
                            isSetup = true;
                        }
                        return;
                    }, function (error) {
                        return $q.resolve();
                    });
                } else {
                    return $q.resolve();
                }
            }

            // Process
            ggFunctions.toggleProcessing(true);
            fetchLocalScore(localScoreId).then(function () {
                if (!isSetup) {
                    return fetchServerScore(scoreId);
                } else {
                    return $q.resolve();
                }
            }).finally(function () {
                if (!isSetup) {
                    if (scoreId > 0 || localScoreId > 0) {
                        $scope.PopupAlert.fail("Fore!", "The score you requested could not be found.");
                    }
                }
                $scope.Score = score;
                $scope.f.formatScoreObject();
                $scope.Content.init();
            });
        }

        var vm = $scope.vm = {};
        vm.strokesGainedChange = strokesGainedChange;

        function strokesGainedChange() {
            var score = $scope.Score,
                temp = $scope.Temp,
                holeNumber = temp.currentHoleNumber,
                par = temp.holes.par[holeNumber - 1],
                holeScore = score.holeScores[holeNumber - 1],
                gross = holeScore.gross;

            holeScore.gross = 0; // <== won't update unless different.
            $scope.f.updateHoleGross({ holeNumber: holeNumber, value: gross, par: par });
        }
    }
}(angular, app));

